import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Structure from './Structure/Structure';
import CreateUser from './User/CreateUser';
import UpdateUser from './User/UpdateUser';
import UserList from './User/UserList';
import CreateRole from './Role/CreateRole';
import UpdateRole from './Role/UpdateRole';
import RoleList from './Role/RoleList';
import Unit from './Dropdowns/Unit';
import Color from './Dropdowns/Color';
import Factory from './Dropdowns/Factory';
import Rack from './Dropdowns/Rack';
import CreateCustomer from './Customer/CreateCustomer';
import UpdateCustomer from './Customer/UpdateCustomer';
import CustomerList from './Customer/CustomerList';
import CreateVendor from './Vendor/CreateVendor';
import UpdateVendor from './Vendor/UpdateVendor';
import VendorList from './Vendor/VendorList';
import CreateStyle from './Style/CreateStyle';
import UpdateStyle from './Style/UpdateStyle';
import StyleList from './Style/StyleList';
import CreateFabric from './Fabric/CreateFabric';
import UpdateFabric from './Fabric/UpdateFabric';
import FabricList from './Fabric/FabricList';
import CreateAccessory from './Accessory/CreateAccessory';
import UpdateAccessory from './Accessory/UpdateAccessory';
import AccessoryList from './Accessory/AccessoryList';
import CreateProduct from './Product/CreateProduct';
import UpdateProduct from './Product/UpdateProduct';
import ProductList from './Product/ProductList';
import CreateJobchart from './Jobchart/NewJobchart';
import JobchartList from './Jobchart/JobchartList';
import PreviewJobchart from './Jobchart/PreviewJobchart';
import TrackingJobchart from './Jobchart/TrackingJobchart';
import EditJobchart from './Jobchart/EditJobchart';
import CreateTimeAction from './TimeAction/CreateTimeAction';
import ViewTimeAction from './TimeAction/ViewTimeAction';
import FabricInventoryList from './FabricInventory/InventoryList';
import AddFabricInInventory from './FabricInventory/AddFabricInInventory';
import UpdateFabricInInventory from './FabricInventory/UpdateFabricInInventory';
import FabricTransferRequestList from './FabricInventory/TransferRequestList';
import FabricTransferForm from './FabricInventory/TransferForm';
import AccessoryInventoryList from './AccessoryInventory/InventoryList';
import AddAccessoryInInventory from './AccessoryInventory/AddAccessoryInInventory';
import UpdateAccessoryInInventory from './AccessoryInventory/UpdateAccessoryInInventory';
import AccessoryTransferRequestList from './AccessoryInventory/TransferRequestList';
import AccessoryTransferForm from './AccessoryInventory/TransferForm';
import CreateIssueReceive from './IssueReceive/IssueReceive';
import ViewChallan from './IssueReceive/ViewChallan';
import CreateRenukaPO from './RenukaPO/CreateRenukaPO';
import UpdateRenukaPO from './RenukaPO/UpdateRenukaPO';
import RenukaPOList from './RenukaPO/RenukaPOList';
import ViewRPO from './RenukaPO/ViewRPO';
import CreateStoreInward from './StoreInward/CreateStoreInward';
import UpdateStoreInward from './StoreInward/UpdateStoreInward';
import StoreInwardList from './StoreInward/StoreInwardList';
import ViewRPOInwards from './StoreInward/ViewRPOInwards';
import CreateStoreOutward from './StoreOutward/CreateStoreOutward';
import UpdateStoreOutward from './StoreOutward/UpdateStoreOutward';
import StoreOutwardList from './StoreOutward/StoreOutwardList';
import MRR from './MRR/MRR';
import OutwardReport from './OutwardReport/OutwardReport';
import CreateQualityCheck from './QualityCheck/CreateQualityCheck';
import UpdateQualityCheck from './QualityCheck/UpdateQualityCheck';
import QualityCheckList from './QualityCheck/QualityCheckList';
import QualityCheckView from './QualityCheck/QualityCheckView';
import DebitNoteList from './QualityCheck/DebitNoteList';
import UpdateTimeAction from './TimeAction/UpdateTimeAction';
import UserTracking from './TimeAction/UserTracking';
import WeeklyPlan from './TimeAction/WeeklyPlan';
import DailyCompletionForm from './DailyCompletion/DailyCompletionForm';
import DailyCompletionList from './DailyCompletion/DailyCompletionList';
import CreateSample from './Sample/CreateSample';
import SampleList from './Sample/SampleList';
import PreviewSample from './Sample/PreviewSample';
import EditSample from './Sample/EditSample';
import SampleIssueForm from './Sample/IssueForm';
import CreateCostSheet from './CostSheet/CreateCostSheet';
import UpdateCostSheet from './CostSheet/UpdateCostSheet';
import CostSheetList from './CostSheet/CostSheetList';
import CreateWorker from './Workers/CreateWorker';
import UpdateWorker from './Workers/UpdateWorker';
import WorkerList from './Workers/WorkerList';
import WorkerJob from './worker-jobs/WorkerJob';
import WorkerJobList from './worker-jobs/WorkerJobList';
import ShowJob from './worker-jobs/ShowJob';
import WorkerIssueList from './worker-issues/WorkerIssueList';
import ShowIssue from './worker-issues/ShowIssue';
import WorkerIssue from './worker-issues/WorkerIssue';
import NotifyFrame from './Notify/NotifyFrame';

const Routes = () => (
  <Structure>
    <Switch>
      <Route path="/" exact component={null} />
      {/* Renuka Notify embedded modules (iframe). ERP routes MIRROR Notify's own
          paths so deep-links in Notify's emails (e.g. /extensions/approvals,
          /extend?task=) resolve here at the shared origin too. */}
      <Route
        path="/performance"
        exact
        render={() => <NotifyFrame path="/perf" title="Performance" />}
      />
      <Route
        path="/extend"
        exact
        render={({ location }) => (
          <NotifyFrame
            path={`/extend${location.search}`}
            title="Request extension"
          />
        )}
      />
      <Route
        path="/extensions/approvals"
        exact
        render={() => (
          <NotifyFrame path="/extensions/approvals" title="Approvals" />
        )}
      />
      <Route
        path="/extensions"
        exact
        render={() => (
          <NotifyFrame path="/extensions" title="Task Extensions" />
        )}
      />
      <Route path="/users/create" exact component={CreateUser} />
      <Route path="/users/update/:id" exact component={UpdateUser} />
      <Route path="/users/list" exact component={UserList} />
      <Route path="/roles/create" exact component={CreateRole} />
      <Route path="/roles/update/:id" exact component={UpdateRole} />
      <Route path="/roles/list" exact component={RoleList} />
      <Route path="/dropdowns/units" exact component={Unit} />
      <Route path="/dropdowns/colors" exact component={Color} />
      <Route path="/dropdowns/factories" exact component={Factory} />
      <Route path="/dropdowns/racks" exact component={Rack} />
      <Route path="/customers/create" exact component={CreateCustomer} />
      <Route path="/customers/update/:id" exact component={UpdateCustomer} />
      <Route path="/customers/list" exact component={CustomerList} />
      <Route path="/vendors/create" exact component={CreateVendor} />
      <Route path="/vendors/update/:id" exact component={UpdateVendor} />
      <Route path="/vendors/list" exact component={VendorList} />
      <Route path="/styles/create" exact component={CreateStyle} />
      <Route path="/styles/update/:id" exact component={UpdateStyle} />
      <Route path="/styles/list" exact component={StyleList} />
      <Route path="/fabrics/create" exact component={CreateFabric} />
      <Route path="/fabrics/update/:id" exact component={UpdateFabric} />
      <Route path="/fabrics/list" exact component={FabricList} />
      <Route path="/accessories/create" exact component={CreateAccessory} />
      <Route path="/accessories/update/:id" exact component={UpdateAccessory} />
      <Route path="/accessories/list" exact component={AccessoryList} />
      <Route path="/products/create" exact component={CreateProduct} />
      <Route path="/products/update/:id" exact component={UpdateProduct} />
      <Route path="/products/list" exact component={ProductList} />
      <Route path="/jobcharts/create" exact component={CreateJobchart} />
      <Route path="/jobcharts/list" exact component={JobchartList} />
      <Route path="/jobcharts/preview/:id" exact component={PreviewJobchart} />
      <Route
        path="/jobcharts/tracking/:id"
        exact
        component={TrackingJobchart}
      />
      <Route path="/jobcharts/edit/:id" exact component={EditJobchart} />
      <Route
        path="/timeactions/create/:jobchartId"
        exact
        component={CreateTimeAction}
      />
      <Route
        path="/timeactions/update/:jobchartId"
        exact
        component={UpdateTimeAction}
      />
      <Route path="/timeactions/tracking" exact component={UserTracking} />
      <Route path="/timeactions/:id" exact component={ViewTimeAction} />
      <Route path="/inventory/fabric" exact component={FabricInventoryList} />
      <Route
        path="/inventory/fabric/add"
        exact
        component={AddFabricInInventory}
      />
      <Route
        path="/inventory/fabric/update/:id"
        exact
        component={UpdateFabricInInventory}
      />
      <Route
        path="/inventory/fabric/transfer/list"
        exact
        component={FabricTransferRequestList}
      />
      <Route
        path="/inventory/fabric/transfer/:id"
        exact
        component={FabricTransferForm}
      />
      <Route
        path="/inventory/accessory"
        exact
        component={AccessoryInventoryList}
      />
      <Route
        path="/inventory/accessory/add"
        exact
        component={AddAccessoryInInventory}
      />
      <Route
        path="/inventory/accessory/update/:id"
        exact
        component={UpdateAccessoryInInventory}
      />
      <Route
        path="/inventory/accessory/transfer/list"
        exact
        component={AccessoryTransferRequestList}
      />
      <Route
        path="/inventory/accessory/transfer/:id"
        exact
        component={AccessoryTransferForm}
      />
      <Route path="/issuereceive/create" exact component={CreateIssueReceive} />
      <Route path="/issuereceive/challan" exact component={ViewChallan} />
      <Route path="/renukapo/create" exact component={CreateRenukaPO} />
      <Route path="/renukapo/update/:id" exact component={UpdateRenukaPO} />
      <Route path="/renukapo/list" exact component={RenukaPOList} />
      <Route path="/renukapo/view/:id" exact component={ViewRPO} />
      <Route path="/storeinward/create" exact component={CreateStoreInward} />
      <Route
        path="/storeinward/update/:id"
        exact
        component={UpdateStoreInward}
      />
      <Route path="/storeinward/list" exact component={StoreInwardList} />
      <Route path="/storeinward/rpo/:rpoId" exact component={ViewRPOInwards} />
      <Route path="/storeoutward/create" exact component={CreateStoreOutward} />
      <Route
        path="/storeoutward/update/:id"
        exact
        component={UpdateStoreOutward}
      />
      <Route path="/storeoutward/list" exact component={StoreOutwardList} />
      <Route path="/mrr" exact component={MRR} />
      <Route path="/outwardreport" exact component={OutwardReport} />
      <Route
        path="/qualitycheck/create/:id"
        exact
        component={CreateQualityCheck}
      />
      <Route
        path="/qualitycheck/update/:storeInwardId/:id"
        exact
        component={UpdateQualityCheck}
      />
      <Route path="/qualitycheck/list" exact component={QualityCheckList} />
      <Route
        path="/qualitycheck/view/:storeInwardId/:id"
        exact
        component={QualityCheckView}
      />
      <Route path="/debitnote/list" exact component={DebitNoteList} />
      <Route path="/weeklyplan" exact component={WeeklyPlan} />
      <Route
        path="/dailycompletion/form"
        exact
        component={DailyCompletionForm}
      />
      <Route
        path="/dailycompletion/list"
        exact
        component={DailyCompletionList}
      />
      <Route path="/samples/create" exact component={CreateSample} />
      <Route path="/samples/list" exact component={SampleList} />
      <Route path="/samples/preview/:id" exact component={PreviewSample} />
      <Route path="/samples/edit/:id" exact component={EditSample} />
      <Route path="/samples/issue/:id" exact component={SampleIssueForm} />
      <Route path="/costsheet/create" exact component={CreateCostSheet} />
      <Route path="/costsheet/update/:id" exact component={UpdateCostSheet} />
      <Route path="/costsheet/list" exact component={CostSheetList} />
      <Route path="/workers/create" exact component={CreateWorker} />
      <Route path="/workers/update/:id" exact component={UpdateWorker} />
      <Route path="/workers/list" exact component={WorkerList} />
      <Route path="/workers/jobs" exact component={WorkerJobList} />
      <Route path="/workers/jobs/add" exact component={WorkerJob} />
      <Route path="/workers/jobs/:id" exact component={ShowJob} />
      <Route path="/workers/issues" exact component={WorkerIssueList} />
      <Route path="/workers/issues/add" exact component={WorkerIssue} />
      <Route path="/workers/issues/:id" exact component={ShowIssue} />
    </Switch>
  </Structure>
);

export default Routes;
